import { Link } from "wouter";
import {
  Container,
  SimpleGrid,
  Card,
  Group,
  Stack,
  Text,
  Title,
  ThemeIcon,
} from "@mantine/core";
import {
  IconBuilding,
  IconUserStar,
  IconBuildingFactory,
  IconServerCog,
  IconTemplate,
} from "@tabler/icons-react";

const adminLinks = [
  {
    label: "Users",
    description: "Manage admin-level user accounts",
    icon: IconUserStar,
    href: "/admin/users",
    color: "blue",
  },
  {
    label: "Tenants",
    description: "Manage tenants and subscriptions",
    icon: IconBuildingFactory,
    href: "/tenants",
    color: "violet",
  },
  {
    label: "Jobs",
    description: "Background jobs and processing queue",
    icon: IconServerCog,
    href: "/admin/jobs",
    color: "orange",
  },
  {
    label: "Companies",
    description: "Global company directory shared across all tenants",
    icon: IconBuilding,
    href: "/admin/companies",
    color: "green",
  },
  {
    label: "Document Templates",
    description: "Manage standard templates available to tenants",
    icon: IconTemplate,
    href: "/admin/templates",
    color: "cyan",
  },
];

export default function AdminDashboard() {
  return (
    <Container size="lg" py="xl">
      <Title order={2} mb="lg">Admin</Title>

      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="md">
        {adminLinks.map((item) => (
          <Card
            key={item.href}
            component={Link}
            href={item.href}
            withBorder
            padding="lg"
            style={{ cursor: "pointer" }}
          >
            <Group>
              <ThemeIcon size="lg" variant="light" color={item.color}>
                <item.icon size={20} />
              </ThemeIcon>
              <Stack gap={2}>
                <Text fw={500}>{item.label}</Text>
                <Text size="sm" c="dimmed">{item.description}</Text>
              </Stack>
            </Group>
          </Card>
        ))}
      </SimpleGrid>
    </Container>
  );
}
